exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-treeselect__control{font-size:.875rem!important}.batch-pick-table{height:75vh;font-size:9pt}", ""]);

// exports
